import { getImageOfSize } from 'lib/wardaImages';
import type { DefaultLoaderProps } from './types';

function defaultLoader({ src, suffix }: DefaultLoaderProps) {
  return getImageOfSize(suffix, src);
}

export default defaultLoader;
